import { useEffect } from "react";
import Button from "../../../../ui/molecules/button";
import Input from "../../../../ui/molecules/input";
import { NotUPResponseDataDTO } from "./dataService/dto";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { setUpAddress, setUpCity, setUpZipCode, UpdateUp } from "./slice";


interface Props {
    close: () => void
    upSelected: NotUPResponseDataDTO
}

export function NotUpPopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const upState = useAppSelector(state => state.notificationUp)

    useEffect(() => {
        dispatch(setUpZipCode(props.upSelected.zipCode))
        dispatch(setUpCity(props.upSelected.city))
        dispatch(setUpAddress(props.upSelected.address))
    }, [])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'CAP'}
                            placeholder="CAP"
                            value={upState.UpUpdateRequest.zipCode}
                            onChangeText={(text) => dispatch(setUpZipCode(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Comune'}
                            placeholder="Comune"
                            value={upState.UpUpdateRequest.city}
                            onChangeText={(text) => dispatch(setUpCity(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <Input
                            label={'Indirizzo'}
                            placeholder="Indirizzo"
                            value={upState.UpUpdateRequest.address}
                            onChangeText={(text) => dispatch(setUpAddress(text))}
                        />
                    </div>
                </div>

            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(UpdateUp({ body: upState.UpUpdateRequest, id: props.upSelected.id }))}
                    />
                </div>
            </div>
        </div>
    )
}